import { useMakeAuthedRequest } from "shared/api/authRequest";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { User } from "shared/types/User";
import { useNavigate } from "react-router-dom";
import useGetUser from "helpers/useGetUser";

// Switch active tenant for the current user
export const useChangeTenant = () => {
  const makeRequest = useMakeAuthedRequest();
  const { refetch } = useGetUser();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const switchTenant = async ({
    id,
    currentId,
  }: {
    id: string;
    currentId: string;
  }) => {
    const result = await makeRequest<User>({
      method: "post",
      url: `/api/ConnectUsers/${currentId}/switch/${id}`,
    });

    return result;
  };

  return useMutation({
    mutationFn: ({ id, currentId }: { id: string; currentId: string }) =>
      switchTenant({ id, currentId }),
    onSuccess: async () => {
      await refetch();
      navigate("/admin");
      // Clear any cached lock queries to avoid cross-tenant data leakage
      queryClient.removeQueries({ queryKey: ["locks"] });
    },
  });
};

export default useChangeTenant;
